import template from './uploadDocumentButton.html';

export default {
  template,
  controllerAs: 'vm',
};
